// BrowserMockup — decorative CSS/HTML replica of the Midani admin dashboard
// in a browser window, used behind the phone on the signup aside.
// Purely presentational (aria-hidden); copy is translated.

import { useTranslation } from 'react-i18next';
import Icon from '@/components/common/Icon';

export interface BrowserMockupProps {
  className?: string;
}

const NAV = [
  { key: 'dashboard', icon: 'layout-grid', labelKey: 'auth_mock_dashboard', active: true },
  { key: 'projects', icon: 'folder', labelKey: 'auth_mock_projects', active: false },
  { key: 'forms', icon: 'file-text', labelKey: 'auth_mock_forms', active: false },
  { key: 'tasks', icon: 'square-check', labelKey: 'auth_mock_tasks', active: false },
  { key: 'inspections', icon: 'clipboard-check', labelKey: 'auth_mock_inspections', active: false },
];

const BARS = [34, 22, 46, 30, 58, 88, 52];

const BrowserMockup = ({ className = '' }: BrowserMockupProps) => {
  const { t } = useTranslation();

  return (
    <div className={['browser-mockup', className].filter(Boolean).join(' ')} aria-hidden='true'>
      <div className='browser-mockup__bar'>
        <span className='browser-mockup__dot browser-mockup__dot--red' />
        <span className='browser-mockup__dot browser-mockup__dot--amber' />
        <span className='browser-mockup__dot browser-mockup__dot--green' />
        <span className='browser-mockup__url'>app.midani.co</span>
      </div>
      <div className='browser-mockup__body'>
        <div className='browser-mockup__sidebar'>
          <span className='browser-mockup__wordmark'>Midani</span>
          {NAV.map((item) => (
            <span
              key={item.key}
              className={[
                'browser-mockup__nav-item',
                item.active && 'browser-mockup__nav-item--active',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              <Icon name={item.icon} size={10} />
              {t(item.labelKey)}
            </span>
          ))}
        </div>
        <div className='browser-mockup__main'>
          <span className='browser-mockup__title'>{t('auth_mock_dashboard')}</span>
          <div className='browser-mockup__stats'>
            <span className='browser-mockup__stat'>
              <span className='browser-mockup__stat-label'>{t('auth_mock_forms')}</span>
              <span className='browser-mockup__stat-value browser-mockup__stat-value--brand'>
                128
              </span>
            </span>
            <span className='browser-mockup__stat'>
              <span className='browser-mockup__stat-label'>{t('auth_mock_tasks')}</span>
              <span className='browser-mockup__stat-value browser-mockup__stat-value--warning'>
                46
              </span>
            </span>
            <span className='browser-mockup__stat'>
              <span className='browser-mockup__stat-label'>{t('auth_mock_issues')}</span>
              <span className='browser-mockup__stat-value browser-mockup__stat-value--danger'>
                9
              </span>
            </span>
          </div>
          <span className='browser-mockup__chart-title'>{t('auth_mock_submissions_week')}</span>
          <div className='browser-mockup__chart'>
            {BARS.map((h, i) => (
              <span
                key={i}
                className={[
                  'browser-mockup__chart-bar',
                  h >= 80 && 'browser-mockup__chart-bar--peak',
                ]
                  .filter(Boolean)
                  .join(' ')}
                style={{ height: `${h}%` }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowserMockup;
